import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");

        if (!sessionId) {
          console.error("No session_id found in URL");
          navigate("/login", { replace: true });
          return;
        }

        // Exchange session_id for user data
        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error("Session validation failed");
        }

        const userData = await response.json();

        // Store user data
        localStorage.setItem("user", JSON.stringify(userData));
        if (userData.session_token) {
          localStorage.setItem("token", userData.session_token);
        }

        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);

        // Redirect based on role
        const roleRoutes = {
          athlete: "/dashboard/athlete",
          coach: "/dashboard/coach",
          scout: "/dashboard/scout",
          agent: "/dashboard/agent",
          admin: "/dashboard/admin",
        };

        const targetRoute = roleRoutes[userData.role] || "/dashboard/athlete";
        navigate(targetRoute, { replace: true, state: { user: userData } });
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-[#FF3B30] flex items-center justify-center mx-auto mb-4 animate-pulse">
          <span className="font-display font-black text-2xl">NSB</span>
        </div>
        <p className="text-zinc-400">Authenticating...</p>
      </div>
    </div>
  );
}
